import { Button } from "@joonapp/web-shared"
import { SessionBooking } from "@joonapp/web-shared"

import useUserRole from "../../../../hooks/useUserRole"
import useSession from "../hooks/useSession"

const NoShowButton = ({ session }: { session: SessionBooking }) => {
  const { handleNoShowSession, showNoShowButton } = useSession(session)
  const { isClientOfOtherCoach } = useUserRole()

  if (!showNoShowButton) return <></>

  return (
    <Button
      text="No-show"
      buttonType="redSecondary"
      onClick={handleNoShowSession}
      fullWidth
      disabled={isClientOfOtherCoach}
    />
  )
}

export default NoShowButton
